export default "__VITE_PUBLIC_ASSET__c8a19ebd__"